import { Injectable } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { DashboardClaim } from '@lsq-frontend/remote-services/enterprise/common';
import { IChecklistItem } from '@lsq-frontend/common-ui';
import { ClaimService } from '@lsq-frontend/common-ui';
import {
    ListAllBusinessUnitNamesAndIdsRequest,
    ListAllBusinessUnitNamesAndIdsService
} from '@lsq-frontend/remote-services/all-java/financing-mk2-services/buyer-account/account-summary/list-all-business-unit-names-and-ids';
import { BusinessUnitNameAndIdDto } from '@lsq-frontend/remote-services/all-java/financing-mk2-services/model/business-unit-name-and-id-dto';
import { BehaviorSubject } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable()
export class SupplyChainDirectAccountService {
    public allBusinessUnitsNamesAndIds$ = new BehaviorSubject<BusinessUnitNameAndIdDto[]>([]);
    public allBusinessUnitsAsChecklistItems$ = this.allBusinessUnitsNamesAndIds$.pipe(
        map((businessUnits) =>
            businessUnits.map(
                (bu) =>
                    ({
                        label: bu.name,
                        value: bu.buyerKey
                    } as IChecklistItem)
            )
        )
    );
    public readonly buyerKeysFormGroup = new FormGroup({
        buyerKeys: new FormControl([])
    });

    constructor(
        private _claimService: ClaimService,
        private _listAllBusinessUnitNamesAndIdsService: ListAllBusinessUnitNamesAndIdsService
    ) {}

    public initialize(): void {
        if (this._claimService.isOnSync(DashboardClaim.FinancingAccountPortal)) {
            this._setUpBusinessUnitFilterAsync();
        }
    }

    private _setUpBusinessUnitFilterAsync(): void {
        this._listAllBusinessUnitNamesAndIdsService
            .executeOnce(new ListAllBusinessUnitNamesAndIdsRequest())
            .then((allBusinessUnitsResponse) => {
                this.allBusinessUnitsNamesAndIds$.next(
                    allBusinessUnitsResponse.businessUnitNames ?? []
                );

                // Initialize to all selected, but DO NOT EMIT the value.
                // Consumers should default to [] unless this value emits otherwise.
                this.buyerKeysFormGroup.setValue(
                    {
                        buyerKeys: (allBusinessUnitsResponse.businessUnitNames ?? []).map(
                            (item) => item.buyerKey as string
                        )
                    },
                    { emitEvent: false }
                );
            });
    }

    public reset(): void {
        this.allBusinessUnitsNamesAndIds$.next([]);
    }
}
